import styled from 'styled-components'

export default styled.a`
  color: ${props => props.theme.colors.interactive};
  text-decoration: none;
  transition: all 250ms ease;
  font-weight: 500;
  cursor: pointer;
`
